import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const TOOLTIP_STYLE = {
  backgroundColor: "#FFFFFF",
  borderRadius: "0px",
  border: "1px solid #E5E2DC",
  boxShadow: "none",
  color: "#1C1B1A",
  padding: "10px 12px",
  fontFamily: "Manrope, sans-serif",
  fontSize: "12px",
};

export default function SentimentChart({ data = [] }) {
  return (
    <div className="w-full h-[280px]" data-testid="sentiment-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 16, left: -8, bottom: 0 }}>
          <defs>
            <linearGradient id="neg" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#D93636" stopOpacity={0.18} />
              <stop offset="100%" stopColor="#D93636" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="pos" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#40593B" stopOpacity={0.16} />
              <stop offset="100%" stopColor="#40593B" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#E5E2DC" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={(d) => (d ? d.slice(5) : "")}
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#6E6B65", fontSize: 11, fontFamily: "Manrope" }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#6E6B65", fontSize: 11, fontFamily: "Manrope" }}
            width={30}
          />
          <Tooltip contentStyle={TOOLTIP_STYLE} itemStyle={{ color: "#1C1B1A" }} cursor={{ stroke: "#A66E4E", strokeWidth: 1 }} />
          <Area
            type="monotone"
            dataKey="negative"
            stroke="#D93636"
            strokeWidth={2}
            fill="url(#neg)"
          />
          <Area
            type="monotone"
            dataKey="positive"
            stroke="#40593B"
            strokeWidth={2}
            fill="url(#pos)"
          />
          <Area
            type="monotone"
            dataKey="neutral"
            stroke="#8C8C8C"
            strokeWidth={1.5}
            fill="transparent"
            strokeDasharray="4 4"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
